import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import { Chip } from '@material-ui/core';

import moment from 'moment';

const styles = theme => ({
  textField: {
    width: 170,
  },
  marginRight: {
    marginRight: theme.spacing(2),
  },
  detailContent: {
    flex: '1 1 auto',
  },
  passContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  },
  passInfo: {
    flex: 1,
    padding: "12px 0",
  },
});

class PassDialog extends Component {
  state = {
    open: this.props.open,
    processing: false,
  };

  startProcessing = () => {
    this.setState({ processing: true });
  }

  stopProcessing = () => {
    this.setState({ processing: false });
  }

  handleRequestClose = () => {
    this.setState({ open: false });
    this.props.onRequestClose();
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.open !== this.state.open) {
      if (nextProps.open) {
        this.setState({
          open: nextProps.open,
        });
      } else {
        this.setState({ open: nextProps.open, });
      }
    }
  }

  render() {
    const { classes } = this.props;

    return (
      <Dialog
        onClose={this.handleRequestClose}
        open={this.state.open}>
        <DialogTitle>Passes</DialogTitle>
        <DialogContent>
          <div>
            {/* Customer */}
            <Typography variant="h6" color="textSecondary">Customer</Typography>
            <div style={{ display: 'flex', flexWrap: 'wrap', }}>
              <TextField
                InputLabelProps={{ shrink: true, }}
                className={`${classes.textField} ${classes.marginRight}`}
                disabled
                label="Name"
                value={(this.props.customer && this.props.customer.name) || ''}
                margin="normal" />
              <TextField
                InputLabelProps={{ shrink: true, }}
                className={`${classes.textField} ${classes.marginRight}`}
                disabled
                label="Phone"
                value={(this.props.customer && this.props.customer.phone) || ''}
                margin="normal" />
              <TextField
                InputLabelProps={{ shrink: true, }}
                className={`${classes.textField}`}
                disabled
                label="Email"
                value={(this.props.customer && this.props.customer.email) || ''}
                margin="normal" />
            </div>
            <br />
            {/* Passes */}
            <Typography variant="h6" color="textSecondary">Passes</Typography>
            <div className={classes.detailContent}>
              {
                this.props.passes.filter(pass => pass.active).map((pass, index) => {
                  var passRecord = this.props.userPass && this.props.userPass[pass.id];

                  var isAvailable = true;
                  var label = "";
                  switch (pass.unit) {
                    case 'time':
                    case 'day':
                      let remaining = (passRecord && passRecord.remaining) || 0;
                      if (remaining > 0) {
                        label = `${remaining} ${pass.unit}${remaining > 1 ? 's' : ''}`;
                      } else {
                        isAvailable = false;
                      }

                      if (passRecord && passRecord.expiryDate) {
                        if (moment(passRecord.expiryDate.toDate()).isAfter(moment())) {
                          label += ` ~ ${moment(passRecord.expiryDate.toDate()).format('ll')}`;
                        } else {
                          isAvailable = false;
                        }
                      }
                      break;
                    case 'month':
                      if (passRecord) {
                        if (pass.activation && !passRecord.activationDate) {
                          label = "Inactive";
                        } if (passRecord.expiryDate && moment(passRecord.expiryDate.toDate()).isAfter(moment())) {
                          label = `~ ${moment(passRecord.expiryDate.toDate()).format('ll')}`;
                        } else {
                          isAvailable = false;
                        }
                      } else {
                        isAvailable = false;
                      }
                      break;
                    default:
                  }

                  return (
                    <div key={pass.id} >
                      <div className={classes.passContainer}>
                        <div className={classes.passInfo}>
                          <div>
                            <Typography variant="caption">
                              {pass.name}
                            </Typography>
                            {' '}
                            <Chip size='small' label={pass.branch} />
                          </div>
                          <Typography variant="body1">
                            {isAvailable ? label : "-"}
                          </Typography>
                        </div>
                      </div>
                      <Divider />
                    </div>
                  );
                })
              }
            </div>

          </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={this.handleRequestClose} >Close</Button>
        </DialogActions>
      </Dialog>
    );
  }
}

PassDialog.propTypes = {
  classes: PropTypes.object.isRequired,
  open: PropTypes.bool.isRequired,
  onRequestClose: PropTypes.func.isRequired,
  passes: PropTypes.array.isRequired,
  customer: PropTypes.object,
  userPass: PropTypes.object,
};

export default withStyles(styles)(PassDialog);
